import React, { useEffect, useRef } from 'react';

// Données extraites du logo Nowatt (1080x1080)
const GREEN = 'rgb(160,211,58)';
const CONTOUR = [[611, 314], [607, 314], [606, 315], [598, 316], [597, 317], [594, 317], [593, 318], [590, 318], [589, 319], [585, 319], [584, 320], [581, 320], [580, 321], [576, 321], [575, 322], [572, 322], [571, 323], [568, 323], [567, 324], [558, 325], [557, 326], [554, 326], [553, 327], [550, 327], [549, 328], [545, 328], [544, 329], [541, 329], [540, 330], [531, 331], [530, 332], [527, 332], [526, 333], [517, 334], [516, 335], [513, 335], [512, 336], [508, 336], [507, 337], [504, 337], [503, 338], [499, 338], [498, 339], [495, 339], [494, 340], [491, 340], [490, 341], [486, 341], [485, 342], [481, 342], [480, 343], [477, 343], [476, 344], [469, 345], [467, 346], [466, 348], [466, 351], [465, 352], [465, 358], [464, 359], [464, 365], [463, 366], [463, 374], [462, 375], [461, 387], [460, 388], [460, 395], [459, 396], [459, 403], [458, 404], [457, 417], [456, 418], [456, 423], [455, 424], [455, 433], [454, 434], [454, 438], [453, 439], [453, 445], [452, 446], [452, 451], [451, 452], [451, 459], [450, 460], [450, 467], [449, 468], [449, 476], [448, 477], [448, 481], [447, 482], [446, 496], [445, 497], [445, 503], [444, 504], [444, 510], [443, 511], [443, 518], [442, 519], [442, 526], [441, 527], [441, 533], [440, 534], [440, 540], [439, 541], [439, 547], [438, 548], [438, 555], [437, 556], [437, 562], [436, 563], [436, 568], [435, 569], [435, 576], [434, 577], [434, 583], [433, 584], [433, 591], [432, 592], [432, 598], [431, 599], [431, 605], [430, 606], [430, 612], [429, 613], [428, 629], [430, 631], [436, 631], [440, 629], [445, 629], [446, 628], [449, 628], [450, 627], [453, 627], [454, 626], [457, 626], [458, 625], [462, 625], [463, 624], [466, 624], [470, 622], [478, 621], [479, 620], [482, 620], [483, 619], [486, 619], [487, 618], [491, 618], [492, 617], [495, 617], [496, 616], [499, 616], [500, 615], [503, 615], [504, 614], [507, 614], [508, 613], [511, 613], [512, 612], [516, 612], [517, 611], [521, 611], [522, 612], [521, 622], [520, 623], [520, 630], [519, 631], [519, 638], [518, 639], [518, 645], [517, 646], [517, 653], [516, 654], [516, 661], [515, 662], [515, 668], [514, 669], [513, 684], [512, 685], [512, 690], [511, 691], [510, 707], [509, 708], [509, 714], [508, 715], [508, 721], [507, 722], [506, 737], [505, 738], [505, 744], [504, 745], [504, 752], [503, 753], [503, 760], [502, 761], [502, 768], [501, 769], [500, 784], [499, 785], [499, 791], [498, 792], [497, 807], [496, 808], [495, 822], [494, 823], [494, 831], [493, 832], [493, 839], [492, 840], [492, 849], [493, 850], [495, 850], [496, 849], [496, 847], [499, 842], [499, 840], [504, 831], [504, 828], [515, 806], [515, 804], [521, 792], [521, 790], [526, 780], [526, 778], [529, 773], [529, 771], [534, 762], [534, 760], [536, 757], [536, 755], [540, 747], [540, 744], [543, 740], [546, 734], [546, 732], [548, 729], [548, 727], [556, 711], [557, 706], [561, 699], [561, 697], [564, 692], [564, 690], [568, 683], [568, 681], [571, 676], [571, 674], [573, 671], [573, 669], [579, 657], [580, 652], [589, 634], [589, 632], [591, 629], [591, 626], [595, 620], [595, 618], [598, 613], [598, 611], [601, 606], [601, 604], [604, 599], [604, 597], [608, 590], [608, 587], [614, 576], [614, 574], [616, 571], [616, 569], [619, 564], [620, 559], [625, 550], [625, 548], [631, 536], [631, 532], [629, 530], [626, 530], [622, 532], [613, 533], [612, 534], [609, 534], [608, 535], [605, 535], [604, 536], [601, 536], [600, 537], [596, 537], [595, 538], [592, 538], [591, 539], [587, 539], [586, 540], [583, 540], [582, 541], [579, 541], [578, 542], [574, 542], [573, 543], [570, 543], [569, 544], [565, 544], [564, 545], [561, 545], [560, 546], [557, 546], [556, 547], [552, 547], [551, 548], [547, 548], [546, 547], [546, 545], [547, 544], [547, 542], [549, 538], [549, 535], [550, 534], [550, 532], [552, 528], [552, 525], [554, 521], [554, 518], [556, 514], [557, 507], [559, 504], [559, 501], [561, 497], [561, 494], [563, 490], [563, 487], [564, 486], [564, 484], [565, 483], [565, 481], [567, 477], [567, 474], [568, 473], [568, 471], [570, 467], [570, 464], [571, 463], [571, 461], [573, 457], [573, 454], [574, 453], [574, 451], [576, 447], [576, 444], [578, 440], [579, 433], [580, 432], [580, 430], [582, 426], [582, 423], [583, 422], [583, 420], [585, 416], [585, 413], [586, 412], [586, 410], [587, 409], [587, 407], [589, 403], [589, 399], [591, 396], [591, 393], [592, 392], [592, 390], [594, 386], [594, 383], [595, 382], [595, 380], [597, 376], [597, 372], [598, 371], [598, 369], [599, 368], [599, 366], [600, 365], [600, 363], [602, 359], [602, 356], [603, 355], [603, 353], [604, 352], [604, 350], [605, 349], [605, 347], [607, 343], [607, 339], [609, 336], [609, 333], [610, 332], [610, 330], [612, 326], [612, 323], [613, 322], [613, 319], [614, 318]];
const BOLT_COLS = {"428": [621, 629], "429": [613, 630], "430": [606, 631], "431": [599, 631], "432": [592, 631], "433": [584, 631], "434": [577, 631], "435": [569, 631], "436": [563, 631], "437": [556, 630], "438": [548, 630], "439": [541, 630], "440": [534, 629], "441": [527, 629], "442": [519, 629], "443": [511, 629], "444": [504, 629], "445": [497, 629], "446": [489, 628], "447": [482, 628], "448": [477, 628], "449": [468, 628], "450": [460, 627], "451": [452, 627], "452": [446, 627], "453": [439, 627], "454": [434, 626], "455": [424, 626], "456": [418, 626], "457": [411, 626], "458": [404, 625], "459": [396, 625], "460": [388, 625], "461": [381, 625], "462": [375, 625], "463": [366, 624], "464": [359, 624], "465": [352, 624], "466": [348, 624], "467": [346, 623], "468": [346, 623], "469": [345, 623], "470": [345, 622], "471": [345, 622], "472": [345, 622], "473": [344, 622], "474": [344, 621], "475": [344, 621], "476": [344, 621], "477": [343, 621], "478": [343, 621], "479": [343, 620], "480": [343, 620], "481": [342, 620], "482": [342, 620], "483": [342, 619], "484": [342, 619], "485": [342, 619], "486": [341, 619], "487": [341, 618], "488": [341, 618], "489": [341, 618], "490": [341, 618], "491": [340, 618], "492": [340, 849], "493": [340, 850], "494": [340, 850], "495": [339, 850], "496": [339, 849], "497": [339, 846], "498": [339, 844], "499": [338, 842], "500": [338, 839], "501": [338, 837], "502": [338, 835], "503": [338, 833], "504": [337, 831], "505": [337, 827], "506": [337, 825], "507": [337, 823], "508": [336, 821], "509": [336, 819], "510": [336, 817], "511": [336, 815], "512": [336, 812], "513": [335, 810], "514": [335, 808], "515": [335, 806], "516": [335, 803], "517": [334, 801], "518": [334, 799], "519": [334, 796], "520": [334, 794], "521": [334, 792], "522": [333, 789], "523": [333, 787], "524": [333, 784], "525": [333, 782], "526": [333, 780], "527": [332, 777], "528": [332, 775], "529": [332, 773], "530": [332, 770], "531": [331, 768], "532": [331, 766], "533": [331, 764], "534": [331, 762], "535": [331, 759], "536": [330, 757], "537": [330, 754], "538": [330, 752], "539": [330, 749], "540": [330, 747], "541": [329, 743], "542": [329, 741], "543": [329, 740], "544": [329, 738], "545": [328, 736], "546": [328, 734], "547": [328, 731], "548": [328, 729], "549": [328, 726], "550": [327, 724], "551": [327, 722], "552": [327, 719], "553": [327, 717], "554": [326, 715], "555": [326, 713], "556": [326, 711], "557": [326, 708], "558": [325, 705], "559": [325, 703], "560": [325, 701], "561": [325, 699], "562": [325, 696], "563": [324, 694], "564": [324, 692], "565": [324, 689], "566": [324, 687], "567": [324, 685], "568": [323, 683], "569": [323, 680], "570": [323, 678], "571": [323, 676], "572": [322, 673], "573": [322, 671], "574": [322, 668], "575": [322, 666], "576": [321, 664], "577": [321, 661], "578": [321, 659], "579": [321, 657], "580": [321, 654], "581": [320, 651], "582": [320, 649], "583": [320, 647], "584": [320, 645], "585": [319, 643], "586": [319, 640], "587": [319, 638], "588": [319, 636], "589": [319, 634], "590": [318, 631], "591": [318, 629], "592": [318, 625], "593": [318, 623], "594": [317, 622], "595": [317, 620], "596": [317, 617], "597": [317, 615], "598": [316, 613], "599": [316, 610], "600": [316, 608], "601": [316, 606], "602": [316, 603], "603": [315, 601], "604": [315, 599], "605": [315, 596], "606": [315, 594], "607": [314, 592], "608": [314, 590], "609": [314, 586], "610": [314, 584], "611": [314, 582], "612": [315, 580], "613": [316, 578], "614": [318, 576], "615": [533, 573], "616": [533, 571], "617": [533, 568], "618": [532, 566], "619": [532, 564], "620": [532, 561], "621": [532, 558], "622": [532, 556], "623": [531, 554], "624": [531, 552], "625": [531, 550], "626": [530, 547], "627": [530, 545], "628": [530, 543], "629": [530, 540], "630": [531, 538], "631": [532, 536]};
const Y_TOP = 314;
const Y_BOT = 850;
const ARC_CX = 539;
const ARC_CY = 486;
const ARC_R = 258;
const LOGO_W = 1080;

// Timeline (secondes)
const OUTLINE_END  = 0.8;
const FILL_START   = 0.8;
const FILL_END     = 2.1;
const ARC_START    = 2.2;
const ARC_END      = 3.4;
const TOTAL        = 3.5;

const W_STROKE_START = 4;
const W_STROKE_END   = 58;
const N_SEG = 300;
const ARROW_SIZE = 140;
const ARC_DEG_START = 120;
const ARC_DEG_TOTAL = 300;

function easeInOut(t) {
  return t * t * (3 - 2 * t);
}

export default function SplashScreen({ onDone }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const DPR = window.devicePixelRatio || 1;
    const SIZE = Math.min(window.innerWidth, window.innerHeight);
    canvas.style.width  = SIZE + 'px';
    canvas.style.height = SIZE + 'px';
    canvas.width  = SIZE * DPR;
    canvas.height = SIZE * DPR;
    ctx.scale(DPR, DPR);

    // Facteur de scale logo → canvas
    const S = SIZE / LOGO_W;

    let startTime = null;
    let rafId = null;

    function drawOutline(progress) {
      const pts = CONTOUR;
      const total = pts.reduce((acc, p, i) => {
        if (i === 0) return 0;
        const dx = pts[i][0] - pts[i-1][0];
        const dy = pts[i][1] - pts[i-1][1];
        return acc + Math.sqrt(dx*dx + dy*dy);
      }, 0);
      const target = progress * total;
      let dist = 0;
      ctx.beginPath();
      ctx.strokeStyle = GREEN;
      ctx.lineWidth = 9 * S;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.moveTo(pts[0][0]*S, pts[0][1]*S);
      for (let i = 1; i < pts.length; i++) {
        const dx = pts[i][0]-pts[i-1][0];
        const dy = pts[i][1]-pts[i-1][1];
        dist += Math.sqrt(dx*dx+dy*dy);
        ctx.lineTo(pts[i][0]*S, pts[i][1]*S);
        if (dist >= target) break;
      }
      ctx.stroke();
    }

    function drawLiquidFill(progress, t) {
      const p = easeInOut(Math.min(1, progress));
      const fillY = Y_BOT - p * (Y_BOT - Y_TOP);
      const waveEnv = Math.sin(Math.PI * p);
      const amp1 = 30 * waveEnv;
      const amp2 = 16 * waveEnv;
      const amp3 = 8  * waveEnv;
      const freq1 = 0.010; const freq2 = 0.022; const freq3 = 0.038;
      const sp1 = 2.8; const sp2 = 5.0; const sp3 = 7.5;

      // Clip to exact bolt contour shape
      ctx.save();
      ctx.beginPath();
      const cpts = CONTOUR;
      ctx.moveTo(cpts[0][0]*S, cpts[0][1]*S);
      for (let i = 1; i < cpts.length; i++) {
        ctx.lineTo(cpts[i][0]*S, cpts[i][1]*S);
      }
      ctx.closePath();
      ctx.clip();

      ctx.fillStyle = GREEN;
      for (const [xStr, [yMin, yMax]] of Object.entries(BOLT_COLS)) {
        const x = parseInt(xStr);
        const wave = amp1*Math.sin(x*freq1 + t*sp1)
                   + amp2*Math.sin(x*freq2 - t*sp2 + 1.3)
                   + amp3*Math.sin(x*freq3 + t*sp3 + 2.7);
        const surfaceY = Math.max(Y_TOP, Math.min(Y_BOT, fillY + wave));
        const drawFrom = Math.max(surfaceY, yMin);
        if (drawFrom <= yMax) {
          ctx.fillRect(x*S, drawFrom*S, S+0.5, (yMax - drawFrom + 1)*S + 0.5);
        }
      }
      ctx.restore();
    }

    function drawArcWithArrow(progress) {
      const p = Math.pow(progress, 0.65);
      const nDraw = Math.max(2, Math.floor(p * N_SEG));

      const pts = []; const widths = [];
      for (let i = 0; i <= nDraw; i++) {
        const t = i / N_SEG;
        const angle = (ARC_DEG_START + t * ARC_DEG_TOTAL) * Math.PI / 180;
        pts.push([ARC_CX + ARC_R * Math.cos(angle), ARC_CY + ARC_R * Math.sin(angle)]);
        widths.push((W_STROKE_START + (W_STROKE_END - W_STROKE_START) * t) / 2);
      }

      ctx.fillStyle = GREEN;
      for (let i = 0; i < nDraw; i++) {
        const [x0,y0] = pts[i]; const [x1,y1] = pts[i+1];
        const w0 = widths[i]; const w1 = widths[i+1];
        const dx = x1-x0; const dy = y1-y0;
        const ln = Math.sqrt(dx*dx+dy*dy);
        if (ln < 0.001) continue;
        const px = -dy/ln; const py = dx/ln;
        ctx.beginPath();
        ctx.moveTo((x0+px*w0)*S, (y0+py*w0)*S);
        ctx.lineTo((x0-px*w0)*S, (y0-py*w0)*S);
        ctx.lineTo((x1-px*w1)*S, (y1-py*w1)*S);
        ctx.lineTo((x1+px*w1)*S, (y1+py*w1)*S);
        ctx.closePath();
        ctx.fill();
      }
      // Cercles joints
      for (let i = 0; i <= nDraw; i++) {
        const [x,y] = pts[i]; const rr = widths[i]*S;
        ctx.beginPath();
        ctx.arc(x*S, y*S, rr, 0, Math.PI*2);
        ctx.fill();
      }

      // Flèche au bout
      const tipT = nDraw / N_SEG;
      const tipAngle = (ARC_DEG_START + tipT * ARC_DEG_TOTAL) * Math.PI / 180;
      const tx = ARC_CX + ARC_R * Math.cos(tipAngle);
      const ty = ARC_CY + ARC_R * Math.sin(tipAngle);
      const TX = -Math.sin(tipAngle); const TY = Math.cos(tipAngle);
      const PX = -TY; const PY = TX;
      const s = ARROW_SIZE * tipT;
      if (s > 8) {
        const bx = tx - TX*s*0.3; const by = ty - TY*s*0.3;
        ctx.beginPath();
        ctx.moveTo((tx+TX*s*0.7)*S, (ty+TY*s*0.7)*S);
        ctx.lineTo((bx+PX*s*0.65)*S, (by+PY*s*0.65)*S);
        ctx.lineTo((bx-PX*s*0.65)*S, (by-PY*s*0.65)*S);
        ctx.closePath();
        ctx.fill();
      }
    }

    function render(timestamp) {
      if (!startTime) startTime = timestamp;
      const elapsed = (timestamp - startTime) / 1000;

      ctx.clearRect(0, 0, SIZE, SIZE);

      // 1. Contour éclair
      const outP = Math.min(1, elapsed / OUTLINE_END);
      drawOutline(outP);

      // 2. Remplissage liquide
      if (elapsed >= FILL_START) {
        const fp = Math.min(1, (elapsed - FILL_START) / (FILL_END - FILL_START));
        drawLiquidFill(fp, elapsed);
      }

      // 3. Arc + flèche
      if (elapsed >= ARC_START) {
        const ap = Math.min(1, (elapsed - ARC_START) / (ARC_END - ARC_START));
        drawArcWithArrow(ap);
      }

      if (elapsed < TOTAL) {
        rafId = requestAnimationFrame(render);
      } else {
        // Animation terminée
        if (onDone) setTimeout(onDone, 200);
      }
    }

    rafId = requestAnimationFrame(render);
    return () => { if (rafId) cancelAnimationFrame(rafId); };
  }, [onDone]);

  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: '#06080C',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
    }}>
      <canvas ref={canvasRef} />
    </div>
  );
}
